import {
  Footer as FooterBase,
  Copyright,
  Column,
  Row,
  Link,
  Container,
  Image,
} from '@front10/landing-page-book/dist/components';
import React from 'react';
import { PropTypes } from 'prop-types';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';

import { mobileQuery } from '../utils/breakpoints';
import appStore from '../assets/images/icons/app-store.svg';
import belivers from '../assets/images/icons/belivers.svg';
import facebook from '../assets/images/icons/facebook.svg';
import instagram from '../assets/images/icons/instagram.svg';
import linkedin from '../assets/images/icons/linkedin-grayscale.svg';
import twitter from '../assets/images/icons/twitter.svg';
import { FAQ_LINKS } from '../constants/links';

const FooterSocial = ({ title, image, href }) => (
  <Column className="col-3 col-sm-3 col-md-1 mb-4">
    <Link href={href} target="_blank">
      <StyledSVG width="32" src={image} tooltip={title} alt={title} />
    </Link>
  </Column>
);

FooterSocial.propTypes = {
  href: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const BorderTop = styled.div`
  position: absolute;

  top: 0;
  width: 100vw;
  height: 2px;

  z-index: -2;

  background: #ececec;
`;

const StyledCopyright = styled(Copyright)`
  font-size: 12px;
`;

const StoreLink = ({ href, src, title }) => (
  <Column className="col-12 col-sm-6 col-md-3 my-3">
    <Link href={href} tooltip={title} target="_blank">
      <Image width="150" src={src} alt={title} />
    </Link>
  </Column>
);

StoreLink.propTypes = {
  href: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const FooterSocialRow = styled(Row)`
  margin-top: 28px;
  margin-bottom: 10px;
  justify-content: center;
`;

const Footer = () => (
  <StyledFooter bgColor="light">
    <Container className="p-3">
      <Row>
        <FooterLink href={FAQ_LINKS.blog} text="Be.Live Blog" />
        <FooterLink href={FAQ_LINKS.articles} text="Knowledge Center" />
        <FooterLink href={FAQ_LINKS.faq} text="FAQ" />
        <FooterLink href={FAQ_LINKS.affiliateProgram} text="Affiliate Program" />
        <FooterLink href={FAQ_LINKS.tos} text="Terms and Conditions" />
        <FooterLink href={FAQ_LINKS.privacy} text="Privacy Policy" />
      </Row>
      <FooterSocialRow className="justify-content-sm-center">
        <FooterSocial
          title="Facebook"
          image={facebook}
          href={FAQ_LINKS.beliveTVApp}
        />
        <FooterSocial
          title="BeLivers Group"
          image={belivers}
          href={FAQ_LINKS.belivers}
        />
        <FooterSocial
          title="Instagram"
          image={instagram}
          href={FAQ_LINKS.instagram}
        />
        <FooterSocial title="Twitter" image={twitter} href="https://twitter.com/belivetv_" />
        <FooterSocial
          title="LinkedIn"
          image={linkedin}
          href={FAQ_LINKS.linkedin}
        />
      </FooterSocialRow>
    </Container>
    <StyledCopyright
      className="mb-3"
      text="All Rights Reserved. Be.Live Studios LTD"
      showAllRightText={false}
    />
  </StyledFooter>
);

export default Footer;

const StyledFooter = styled(FooterBase)`
  background-color: #eaebec !important;  
  color: #8daeba;
  position: relative;
  overflow: hidden;
  

  padding: 32px 0 16px !important;
`;

const StyledLink = styled(Link)`
  &, &:hover {
    color: #8daeba;
  }

  font-size: 16px;

  transition: all 0.3s ease;

  @media ${mobileQuery} {
    font-size: 16px;
  }
`;

const FooterLink = ({ href, text }) => (
  <Column className="col-6 col-sm-4 text-center mb-4">
    <StyledLink href={href} target="_blank">
      {text}
    </StyledLink>
  </Column>
);

FooterLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

const StyledSVG = styled(SVG)`
  fill: #8daeba;
  stroke: #8daeba;
  
  path,
  g {
    transition: all 0.3s ease;
  }

  &:hover {
    filter: brightness(1.2);
    path[fill='#7C7C7C'],
    g[fill='#7C7C7C'] {
      fill: var(--bl-yellow-dark);
    }

    path[stroke='#7C7C7C'] {
      stroke: var(--bl-yellow-dark);
    }
  }
`;
